import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GA_ID } from "../lib/BranchGaMap";
import { trackPageview } from "../lib/analytics";

function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname, GA_ID);
  }, [location]);

  return null;
}

export default AnalyticsListener;